import { Component, Input, model } from '@angular/core';

@Component({
    selector: 'c-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrl: './checkbox.component.css',
    standalone: false
})
export class CheckboxComponent {
  valor = model<boolean>(false);
  @Input() etiqueta = 'Inserte etiqueta';
  @Input() readonly = false;
  @Input() center = true;
}
